import { Global } from '@emotion/react';

import { font, reset } from '@common/styles';

import '@common/carousel/swiper/styles.css';
import 'react-day-picker/style.css';

/**
 * 전역 스타일을 제공하는 컴포넌트입니다.
 *
 * 다음 스타일들을 포함합니다:
 * - CSS reset 스타일
 * - 폰트 스타일 (Pretendard)
 * - Swiper 캐러셀 스타일
 * - React Day Picker 스타일
 *
 * @example
 * ```tsx
 * import { GlobalStyles } from '@common/components';
 *
 * function MyApp({ Component, pageProps }) {
 *   return (
 *     <RootContextProvider>
 *       <GlobalStyles />
 *       <Component {...pageProps} />
 *     </RootContextProvider>
 *   );
 * }
 * ```
 */
export const GlobalStyles = () => {
  return (
    <>
      <Global styles={reset} />
      <Global styles={font} />
    </>
  );
};
